import './index.scss';
import { render } from 'react-dom';
import { HashRouter } from 'react-router-dom';
import { App } from './App';
import { createStore } from './createStore';
import { MedalliaFeedback } from '@chr/navisphereonline-shared-components';
import { ConfigContext, OnlineProvider, ToastContainer } from '@chr/navisphereonline-shared-components';
import { OnlineTranslationProvider } from '@chr/online-shared-ui-localizations';

export const bootstrap = (config: AppConfig) => {

  const store = createStore(config);

  render(
    <OnlineTranslationProvider>
      <OnlineProvider appConfig={config} defaultTheme="Navisphere Online">
        <MedalliaFeedback />
        <ToastContainer />
        <HashRouter>
          <ConfigContext.Provider value={config}>
            <App store={store} />
          </ConfigContext.Provider>
        </HashRouter>
      </OnlineProvider>
    </OnlineTranslationProvider>,
    document.getElementById('root')
  );
};
